import React, { useEffect } from "react";
import Routes from "./routes";
import { connect } from "react-redux";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { notify } from "./utils/notifications";
import Loader from "./components/Loader";

const App = ({
  alert,
  resetAlert,
  checkSessionStatus,
  showLoading
}) => {
  useEffect(() => {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      checkSessionStatus();
    }

    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
          console.log("Cache deleted:", name);
        });
      });
    }
  }, [checkSessionStatus]);

  useEffect(() => {
    if (alert.showAlert) {
      notify(alert.type, alert.title, alert.message);
      resetAlert();
    }
  }, [alert, resetAlert]);

  return (
    <>
      {showLoading && <Loader show={showLoading} />}
      <ReactNotifications />
      <Routes />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    alert: state.alertState,
    showLoading: state.loadingState.show,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetAlert: () =>
      dispatch({
        type: "RESET_ALERT",
      }),
    checkSessionStatus: () =>
      dispatch({
        type: "CHECK_SESSION_STATUS_REQUEST",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
